import {CanActivateFn, Router} from '@angular/router';
import {UserDataService} from '../services/userData.service';
import {inject} from '@angular/core';

export const isNotSignedInGuard: CanActivateFn = (route, state) => {
  const userService = inject(UserDataService);
  const router = inject(Router);

  if(!userService.isLoggedIn()) {
    return true;
  } else {
    return router.createUrlTree(['/app']);
  }
};
